import React, { useState } from 'react';
import { Form, Input, Space, Button } from 'antd';
import { useSelector } from 'react-redux';
import { shareClassroomLink } from '../../support/serverRoutes';
import copyToClipboard from '../../../main/utils/helpers/copyToClipboard';

function StepTwo({ locales }) {
  const {
    classroom: {
      current: { secretToken, name },
    },
  } = useSelector((state) => state);
  const [isCopied, setCopied] = useState(false);

  return (
    <>
      <div className="jumbotron">
        <h3 className="step-two-classname">{name}</h3>
        <div className="step-two-title">
          {locales.admin.successfullyCreated}
        </div>
      </div>
      <Form layout="vertical">
        <Form.Item
          label={locales.admin.shareLinkWithStudents}
          className="admin-input-label"
        >
          <Input
            className="admin-input"
            value={shareClassroomLink(secretToken)}
          />
          <p className="description">
            {locales.admin.anyoneSigningUpWithThisLink}
          </p>
        </Form.Item>
        <div
          style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 40 }}
        >
          <Space align="end">
            <Button
              type="primary"
              onClick={() => {
                copyToClipboard(shareClassroomLink(secretToken));
                setCopied(true);
              }}
            >
              {isCopied ? locales.admin.copied : locales.admin.copyLink}
            </Button>
          </Space>
        </div>
      </Form>
    </>
  );
}

export default StepTwo;
